import VueRouter from 'vue-router';
import { magic } from '@gig/magic-sdk';
import { modalService } from '@gig/magic-common';
import { RouteName } from '../../../routes/routes.constants';
import { IGetUserRestrictionsResponse } from '@gig/magic-sdk/dist/adapter/responsiblegaming/getUserRestrictions';
import { COREX_GRACE_PERIOD_QUERY } from '@gig/magic-messages';
import { CoreXLimitStatus } from '@gig/magic-sdk/dist/adapter/responsiblegaming/getUserTransactionLimits';
/**
 * Guard to check if user is in grace period
 * @param router
 */

let hasShownGracePeriodModal = false;

export function initGracePeriodCorexGuard(router: VueRouter) {
    router.beforeEach(async (to, from, next) => {
        const user = magic.session.getUser()!;

        if (!user || to.name === RouteName.LOGOUT) {
            return next();
        }

        const restriction =
            await window.queryBus.query<IGetUserRestrictionsResponse>(
                COREX_GRACE_PERIOD_QUERY,
            );

        const userInGracePeriod =
            restriction?.status === CoreXLimitStatus.ACTIVE ||
            new Date(restriction?.startsOn) > new Date();

        if (userInGracePeriod && !hasShownGracePeriodModal && !isModalOpen()) {
            openModal();
            hasShownGracePeriodModal = true;
            return next({ name: RouteName.HOME });
        }

        next();
    });
}

function openModal() {
    const modal = document.createElement('magic-corex-grace-period-modal');
    const header = 'grace-period-modal.title';
    const modalOptions = {
        dismissible: false,
        displayOnTop: true,
        keepAfterClear: true,
    };
    modalService.open(header, modal, modalOptions);
}

function isModalOpen() {
    return (
        document.getElementsByTagName('magic-corex-grace-period-modal')
            .length != 0
    );
}
